<template>
	<div>
		<!-- 通用领取开始-->
		<div class='actModules'>
			<h3 class='actModules_title' v-text="modulesTitle"></h3>
			<p class='actModules_descripe line' v-html="modulesRules"></p>
			<div class='actSlider vertical'>

					<div class='actSlider_tab' :class="'actSlider_tab-' + tabSize">
						<a
							href='javascript:;'
							class='actSlider_tabItems'
							:class="{'active':activeIndex == index}"
							v-for="(tabItem,index) in tabItems"
							:key="tabItem.index"
							@click="activeIndex=index"
						>{{tabItem.tabText}}</a>
					</div>
					<div>
						<div class='actSlider_content' v-show="activeIndex === index" v-for="(tabItem, index) in tabItems" :key="index">
							<div class='actSlider_contentItems'>
								<img v-if="tabItem.image" :src="tabItem.image">
							</div>
							<div class='actModules_btnWrap'>
								<template v-if="!!geted[index]">
									<a href="javascript:;" class="disabled actModules_btn" v-text="tabItem.buttonName"></a>
								</template>
								<template v-else>
									<a href="javascript:;" @click="doAction" class="actModules_btn" v-text="tabItem.buttonName"></a>
								</template>
							</div>
						</div>
					</div>
			</div>

		</div>
		<!-- 通用领取结束-->
	</div>
</template>

<script>
import '../../assets/css/reset.css';
import bus from '../../../bus';
export default {
	name: 'pc-four-vertical',
	actConfig: {
		labels: { // 字段名称，用于显示在配置系统上，在正式环境会删除
			modulesTitle: '头部文案',
			bgImg: '背景图片',
			modulesRules: '规则描述',
			tabItems: '选项',
			name: '名称',
			image: '图片',
			action: '动作',
			tabText: 'Tab文案',
			buttonName: '按钮文案',
		},
	},
	props: {
		modulesTitle: {
			type: String,
			default: '模块名字',
		},
		bgImg: {
			type: String,
			default: '',
		},
		modulesRules: {
			type: String,
			default: '活动规则：规则文案规则文案规则文案规则文案规则文案规则文案规则文案规则文案规则文案规则文案规则文案规则文案规则文案规则文案规则文案',
		},
		tabItems: {
			type: Array,
			default () {
				return [
					{
						tabText: '1',
						image: '111',
						action: {
							class: 'action',
							type: 'no', // ams link alert
							value: '', //
						},
						buttonName: '功能按钮1',
					},
					{
						tabText: '2',
						image: '222',
						action: {
							class: 'action',
							type: 'no', // ams link alert
							value: '', //
						},
						buttonName: '功能按钮2',
					},
					{
						tabText: '3',
						image: '222',
						action: {
							class: 'action',
							type: 'no', // ams link alert
							value: '', //
						},
						buttonName: '功能按钮3',
					},
					{
						tabText: '4',
						image: '222',
						action: {
							class: 'action',
							type: 'no', // ams link alert
							value: '', //
						},
						buttonName: '功能按钮4',
					}
				]
			}
		}
	},
	data () {
		return {
			activeIndex: 0,
			tabSize: 4,
			geted: [false, false, false, false]
		};
	},
	mounted () {
		bus.$on('giftReceivedStatus', (isGetedh5) => {
			if (typeof (isGetedh5) === 'undefined') {
				return
			}
			for (let i = 0; i < this.tabItems.length; i++) {
				let idx = this.tabItems[i].action.flowid
				if (typeof (isGetedh5['h' + idx]) !== 'undefined') {
					if (isGetedh5['h' + idx][0] > 0 && isGetedh5['h' + idx][1] === '0') {
						this.$set(this.geted, i, true)
						// this.geted[i] = true
					} else {
						this.geted[i] = false
					}
				} else {
					this.geted[i] = false
				}
			}
		})
	},
	methods: {
		doAction () {
			const itemConf = this.tabItems[this.activeIndex];
			this.$doAction(itemConf.actionType, itemConf.action);
		}
	}
};
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style scoped lang='scss'>
//引入 scss 模块组件
@import '../../assets/scss/common';

.actSlider {
  width: 1000px;
  margin: 25px auto 0;
  background: #d8d8d8;

  &.vertical {
    @extend %clearfix;

    .actSlider_tab {
      @extend %left;
      width: 210px;
      padding: 30px 10px;
    }

    .actSlider_content {
      @extend %left;
      width: 790px;
    }

    .actSlider_tabItems {
      width: 190px;
    }
  }

  &.one {
    height: 460px;
  }
}

.actSlider_tab {
  @extend %clearfix;

  // &.actSlider_tab-7 {
  //   .actSlider_tabItems {
  //     width: 14.285%;
  //   }
  // }

  // &.actSlider_tab-6 {
  //   .actSlider_tabItems {
  //     width: 16.66666%;
  //   }
  // }

  // &.actSlider_tab-5 {
  //   .actSlider_tabItems {
  //     width: 20%;
  //   }
  // }

  // &.actSlider_tab-4 {
  //   .actSlider_tabItems {
  //     width: 25%;
  //   }
  // }

  // &.actSlider_tab-3 {
  //   .actSlider_tabItems {
  //     width: 33.33333%;
  //   }
  // }

  // &.actSlider_tab-2 {
  //   .actSlider_tabItems {
  //     width: 50%;
  //   }
  // }
}

.actSlider_tabItems {
  height: 80px;
  line-height: 80px;
  font-size: 24px;
  text-align: center;
  background: #a4a4a4;
  color: #4a4a4a;
  @extend %block;
  @extend %left;
  border: 1px solid #666666;

  &.active {
    background: #d8d8d8;
  }
}

.actSlider_contentItems {
  width: 940px;
  height: 380px;
  img {
    width: 100%;
    height: 100%;
  }
  .vertical & {
    width: 720px;
    height: 400px;
  }
}

.actSlider_content {
  width: 1000px;
  padding: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/actModules/pc/templates/receive-v/x-four-vertical.vue